import { IconTypesProps } from './iconTypes'

const SvgStatusWarning = ({
    primaryColor = '#010101',
    secondaryColor = '#FF8A00',
    reverse,
    dataTestId,
    width,
    height,
}: IconTypesProps) => {
    if (reverse) {
        const tempPrimaryColor = primaryColor
        primaryColor = secondaryColor
        secondaryColor = tempPrimaryColor
    }
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={dataTestId}
        >
            <circle cx="12" cy="12" r="12" fill={secondaryColor} />
            <rect
                x="10.875"
                y="6.375"
                width="2.25"
                height="7.5"
                fill={primaryColor}
            />
            <rect
                x="10.875"
                y="15.375"
                width="2.25"
                height="2.25"
                fill={primaryColor}
            />
        </svg>
    )
}

export default SvgStatusWarning
